import React from 'react';

const packageTypes = [
  'zero_power',
  'single_vision',
  'bifocal',
  'tinted_sv',
  'contact_lens',
  'sunglasses',
];
function ReturnProductDetails(props) {
  const {
    item,
    dataLocale: { PRODUCT_IMG, SYMBOL_PLUS, CURRENCY_SYMBOL },
    exchangewith,
    returnedProductPrice,
  } = props;
  const {
    options = [],
    brandName,
    thumbnail,
    productTypeValue,
    modelName,
    contactDisposableType,
    frameColour,
    frameShape,
    frameType,
    amount,
  } = item || {};
  let lensPackage;
  let coating;
  let type;
  for (let i = 0, len = options.length; i < len; i++) {
    type = options[i].type && options[i].type.toLowerCase();
    if (packageTypes.includes(type)) {
      lensPackage = options[i].name;
    } else if (type === 'coating') {
      coating = options[i].name;
    }
  }
  let price = 0;
  if (amount) {
    const { total, discounts } = amount;
    const paidPrice = discounts.reduce((totalPrice, discount) => {
      if (['sc', 'exchange'].includes(discount.type)) {
        totalPrice += discount.amount;
        return totalPrice;
      }
      return null;
    }, 0);
    price = total + paidPrice;
  }
  return (
    <div>
      {' '}
      {/* className={`${exchangewith ? '' : 'border-right'}`} */}
      <div
        className={`border-radius10 width85 text-center padding-1 ${
          exchangewith ? 'border-topaz text-color_green' : 'border'
        }`}
      >
        {!exchangewith ? 'Product Returned' : 'Exchanged With'}
      </div>
      <div className="margin-t12 margin-b12">
        <img alt={PRODUCT_IMG} className="margin-t15" src={thumbnail} width="84%" />
      </div>
      <div className="fsp15 inline-block mr-b5 w70">
        {brandName && <div className="margin-t4 fs16 fw500 margin-b7">{brandName}</div>}
      </div>
      {frameColour && frameShape && (
        <div className="fs12 text-color-grey">
          {frameColour} {frameShape}
          {frameType && <span className="text-capitalize"> {frameType.replace('_', ' ')}</span>}
        </div>
      )}
      {lensPackage && (
        <div key="lens-package" className="fs12 text-color-grey margin-t3 margin-b3">
          {SYMBOL_PLUS} {lensPackage}
        </div>
      )}
      {coating && (
        <div key="coating" className="fs12 text-color-grey">
          + {coating}
        </div>
      )}
      {productTypeValue !== 'Eyeglasses' && productTypeValue !== 'Sunglasses' && modelName && (
        <div className="fs12 text-color-grey">{modelName}</div>
      )}
      {productTypeValue === 'Contact Lens' && contactDisposableType && (
        <div className="fs12 text-color-grey">{contactDisposableType}</div>
      )}
      {returnedProductPrice > Math.round(price) ? (
        <div className="fs14 tfw500 margin-t10">
          {CURRENCY_SYMBOL} {(returnedProductPrice && Math.round(returnedProductPrice)) || 0}
        </div>
      ) : (
        <div className="fs14 tfw500 margin-t10">
          {CURRENCY_SYMBOL} {(price && Math.round(price)) || 0}
        </div>
      )}
    </div>
  );
}

export default ReturnProductDetails;
